var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo"},[_c('video',{staticClass:"videoItems",staticStyle:{"object-fit":"cover"},attrs:{"width":"664","height":"470","controls":"","controlslist":_vm.videolists.controlslist,"poster":"https://jdqny.com/jdweb/shipinfengming.png","loop":""}},[_c('source',{attrs:{"src":"https://jdqny.com/jdweb/xuanchuanshipin.mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }